import React from 'react';
import clsx from 'clsx';
import styles from './Content.module.scss';
export const Content = ({ children, isScrollable = true }) => {
    return (<div id='owners-layout-content' className={clsx(styles.content, !isScrollable && styles.notScrollable)}>
      {children}
    </div>);
};
